export * from "./news-article";
